import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  return _openBlock(), _createBlock(_component_el_select, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    "default": _withCtx(function () {
      return [$props.showAll ? (_openBlock(), _createBlock(_component_el_option, {
        key: 0,
        label: $props.allLabel,
        value: $props.allValue
      }, null, 8, ["label", "value"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
  }, 16);
}